
export default {
  name: 'FooterComponent',
  props: {
    footer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    year() {
      return new Date().getFullYear();
    }
  },
  methods: {
    isSvg(imageAttributes) {
      if (!imageAttributes || !imageAttributes.url) return false;
      return imageAttributes.url.toLowerCase().endsWith('.svg');
    }
  }

}
